import styled from 'styled-components'
import { colors } from '@/styles'
import { Label } from '@/components/text'

export const Header = styled.div<{ minimized?: boolean }>`
  background-color: ${colors.grey96};
  color: ${colors.grey08};
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  ${props =>
    props.minimized &&
    `
    border-radius: 8px;
  `}
`

export const HeaderButton = styled.button`
  border: none;
  background: none;
  border: none;
  padding: 0;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  color: ${colors.grey56};
`

const TextLabel = styled(Label)`
  color: ${colors.grey32};
  line-height: 16px;
`

export const Text: React.FC<{}> = ({ children, ...rest }) => {
  return (
    <TextLabel fontSize="12px" type="small" {...rest}>
      {children}
    </TextLabel>
  )
}
